/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Premium_Blocked_Comp_TitleInputs */

const en_premium_blocked_comp_title = /** @type {(inputs: Premium_Blocked_Comp_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You already have Premium`)
};

const es_premium_blocked_comp_title = /** @type {(inputs: Premium_Blocked_Comp_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ya tienes Premium`)
};

/**
* | output |
* | --- |
* | "You already have Premium" |
*
* @param {Premium_Blocked_Comp_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const premium_blocked_comp_title = /** @type {((inputs?: Premium_Blocked_Comp_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Premium_Blocked_Comp_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_premium_blocked_comp_title(inputs)
	return en_premium_blocked_comp_title(inputs)
});